(() => {
  angular
    .module('app.settings')
    .controller('IntegrationsSettingsController', IntegrationsSettings);

  IntegrationsSettings.$inject = [
    '$http',
    '$scope',
    '$route',
    '$location',
    'ModalService',
    'SettingsService',
    'AdformNotification',
    'DcmNotification',
  ];

  function IntegrationsSettings(
    $http,
    $scope,
    $route,
    $location,
    ModalService,
    SettingsService,
    AdformNotification,
    DcmNotification,
  ) {
    // because of route configuration, integrations data is already resolved in the service by the time this is called
    const vm = this;
    const cid = $('#current-user').data('cid');

    const httpStatus = {
      ok: 200,
      success: 204,
    };

    /* ************************************************************* */
    /* ************************** Adform *************************** */
    /* ************************************************************* */
    vm.isV2Enabled = SettingsService.isV2Enabled();
    // vm.isV2Enabled = false;
    vm.deactivateAdformIntegrationV1 = () => {
      SettingsService.setAdformSettings({
        active: false,
        username: '',
        password: '',
      });
    };

    const adformDataProvider = () => {
      const path = '/api/adform';

      return {
        oauth: `${path}/oauth/${cid}`,
        fetchMedias: () => $http.get(`${path}/medias`),
        fetchClients: () => $http.get(`${path}/advertisers`),
        fetchIntegrations: () => $http.get(`${path}/integrations`),
        updateIntegrations: data => $http.patch(`${path}/integrations`, data),
        activateIntegrations: () => $http.post(`${path}/integrations/activate`),
        deactivateIntegrations: () => $http.delete(`${path}/integrations`),
      }
    };

    const integrationsProvider = adformDataProvider();
    const removeBackdrop = () => $('.modal-backdrop.fade.in').remove();
    const allowedCountries = ['DE', 'DK', 'FI', 'GB', 'NO', 'SE', 'VN'];
    const allowedMetrics = [{
      key: 'Viewability',
      name: 'Viewability',
    }, {
      key: 'GeoCompliance',
      name: 'Geo compliance',
    }, {
      key: 'Transparency',
      name: 'Transparency',
    }];

    const loadIntegrations = () => {
      vm.processBusy = true;
      return integrationsProvider.fetchIntegrations()
        .then(({ data }) => {
          vm.adformIntegrations = { ...data };

          const statusActive = ['Active', 'Failed', 'InternalError'];
          if (statusActive.includes(data.status)) {
            vm.adformActive = true;
          }

          if (data.status !== 'Failed') {
            AdformNotification.hide();
          }
        })
        .catch(error => {
          console.error(error);
          vm.adformIntegrations = {};
        })
        .finally(() => {
          vm.processBusy = false;
        });
    };

    loadIntegrations()
      .then(() => {
        vm.isV2Enabled = SettingsService.isV2Enabled();

        const { current } = $route;
        if (current && current.params && current.params.edit) {
          vm.openAdformEditModal();
        }
      });

    vm.openAdformEditOrConnectModal = active => {
      if (active) {
        vm.openAdformEditModal();
      } else {
        vm.openAdformModal();
      }
    };

    vm.openAdformModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/adform/adform.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'AdformModalController',
          controllerAs: 'adformModal',
          inputs: {
            provider: integrationsProvider,
            allowedCountries,
            allowedMetrics,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              loadIntegrations();
            }
          });
        });
    };

    vm.openAdformEditModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/adform/adformEdit.html?v=${window.BUILD_VERSION}`,
          controller: 'AdformEditModalController',
          controllerAs: 'adformEditModal',
          inputs: {
            provider: integrationsProvider,
            integrations: vm.adformIntegrations,
            allowedCountries,
            allowedMetrics,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              loadIntegrations();
            }

            const { current } = $route;
            if (current && current.params && current.params.edit) {
              $location.path('/apiintegrations').search({});
            }
          });
        });
    };

    vm.openAdformConfirmDeactivateModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/adform/adformConfirmDeactivate.html?v=${window.BUILD_VERSION}`,
          controller: 'AdformConfirmDeactivateModalController',
          controllerAs: 'adformConfirmDeactivateModal',
          inputs: {
            type: 'adform',
            provider: integrationsProvider,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result && result.status === httpStatus.success) {
              vm.adformActive = false;
              AdformNotification.hide();
            }
          });
        });
    };

    vm.redirectAdformLog = () => {
      $location.path('/log/adform').search({});
    };



    /* ************************************************************* */
    /* ************************ Adform PPAS ************************ */
    /* ************************************************************* */

    const adformPpasDataProvider = () => {
      const path = '/api/ppas';

      return {
        fetchIntegrations: () => $http.get(`${path}/integrations`),
        updateIntegrations: data => $http.patch(`${path}/integrations`, data),
        activateIntegrations: data => $http.post(`${path}/integrations`, data),
        deactivateIntegrations: () => $http.delete(`${path}/integrations`),
        fetchAllIntegrations: () => $http.get(`${path}/allintegrations`),
      }
    };

    const ppasIntegrationProvider = adformPpasDataProvider();

    const loadPpasIntegrations = () => {
      vm.processPpasBusy = true;

      ppasIntegrationProvider.fetchIntegrations()
        .then(({ data }) => {
          vm.adformPpasIntegrations = { ...data };

          vm.adformPpasActive = data && data.status === 'Active';
        })
        .catch(({ data }) => {
          console.error(data.errorMessage);
        })
        .finally(() => {
          vm.processPpasBusy = false;
        });
    };
    loadPpasIntegrations();

    vm.openAdformPpasModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/adform/adformPpas.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'AdformPpasModalController',
          controllerAs: 'adformPpasModal',
          inputs: {
            provider: ppasIntegrationProvider,
            trackingCode: cid,
            allowedCountries,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(data => {
            removeBackdrop();

            if (data) {
              loadPpasIntegrations();
            }
          });
        });
    };

    vm.openAdformPpasEditModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/adform/adformPpasEdit.html?v=${window.BUILD_VERSION}`,
          controller: 'AdformPpasEditModalController',
          controllerAs: 'adformPpasEditModal',
          inputs: {
            provider: ppasIntegrationProvider,
            integrations: vm.adformPpasIntegrations,
            allowedMetrics,
            allowedCountries,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              loadPpasIntegrations();
            }

            const { current } = $route;
            if (current && current.params && current.params.edit) {
              $location.path('/apiintegrations').search({});
            }
          });
        });
    };

    vm.openAdformPpasEditOrActivateModal = active => {
      if (active) {
        vm.openAdformPpasEditModal();
      } else {
        vm.openAdformPpasModal();
      }
    };

    vm.openAdformPpasConfirmDeactivateModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/adform/adformConfirmDeactivate.html?v=${window.BUILD_VERSION}`,
          controller: 'AdformPpasConfirmDeactivateModalController',
          controllerAs: 'adformConfirmDeactivateModal',
          inputs: {
            type: 'ppas',
            provider: ppasIntegrationProvider,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result && result.status === httpStatus.success) {
              vm.adformPpasActive = false;
            }
          });
        });
    };


    /* ************************************************************* */
    /* ************************ DoubleClick ************************ */
    /* ************************************************************* */
    vm.dfp = {};
    const { token, accountId, dfpUrl } = window.DFP_CONFIG;

    $http({
      url: dfpUrl + accountId,
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` }
    }).then(({ data }) => {
      const {
        status,
        message,
        data: { sakId, networkCode, defaultCountry, clickTrackingPrefix, creativeWrapper }
      } = data;
      vm.dfp = {
        sakId,
        status,
        accountId,
        networkCode,
        defaultCountry,
        clickTrackingPrefix,
        message,
        creativeWrapper
      };
    });

    vm.openDFPModal = () => {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/settings/modals/dfp.html?v=0',
          controller: 'DFPModalController',
          controllerAs: 'DFPModal',
          inputs: {
            dfp: vm.dfp
          }
        })
        .then((modal) => {
          modal.element.modal();
          modal.close.then(({ status, message }) => {
            vm.dfp = {
              ...vm.dfp,
              status,
              message
            };
          });
        });
    };

    vm.openDFPEditModal = () => {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/settings/modals/dfp.edit.html?v=0',
          controller: 'DFPEditModalController',
          controllerAs: 'DFPEditModal',
          inputs: {
            dfp: vm.dfp
          }
        })
        .then((modal) => {
          modal.element.modal();
          // modal.close.then(() => {});
        });
    };

    vm.gotoDFPStatus = () => {
      $location.path('apiintegrations/dfp');
    };



    /* ************************************************************* */
    /* **************** DoubleClick Campaign Manager *************** */
    /* ************************************************************* */
    const dcmProvider = () => {
      const path = '/api/dcm';

      return {
        oauth: () => $http.get(`${path}/oauth/${cid}`),
        reconnect: params => $http.get(`${path}/reconnect`, { params }),
        fetchClients: params => $http.get(`${path}/advertisers`, { params }),
        fetchAccounts: params => $http.get(`${path}/accounts`, { params }),
        fetchIntegration: params => $http.get(`${path}/integration`, { params }),
        fetchIntegrations: () => $http.get(`${path}/integrations`),
        updateIntegration: params => $http.patch(`${path}/update`, params),
        activateIntegration: params => $http.post(`${path}/activate`, params),
        deactivateIntegration: params => $http.delete(`${path}/deactivate`, { params }),
        deleteIntegration: params => $http.delete(`${path}/delete`, { params }),
      }
    };

    const dcmIntegrationsProvider = dcmProvider();

    vm.isDcmIntegrationActive = ({ status }) => (
      status === 'Active' || status === 'Failed' || status === 'InternalError');
    vm.isDcmIntegrationFailed = ({ status }) => status === 'Failed';
    vm.isDcmIntegrationInternalError = ({ status }) => status === 'InternalError';

    const loadDcmIntegrations = () => {
      vm.isProcessDcmBusy = true;
      return dcmIntegrationsProvider.fetchIntegrations()
        .then(({ data }) => {
          vm.dcmIntegrations = [];

          data.forEach(item => {
            vm.dcmIntegrations.push({
              ...item,
              name: item.googleAccountName || item.id,
              isProcessBusy: false,
            })
          });

          if (!vm.dcmIntegrations.find(item => item.status === 'Failed')) {
            DcmNotification.hide();
          }
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vm.isProcessDcmBusy = false;
        });
    };

    loadDcmIntegrations()
      .then(() => {});

    vm.activateDcmIntegration = integration => {
      integration.isProcessBusy = true;
      dcmIntegrationsProvider.activateIntegration({
        integrationId: integration.id,
      }).then(() => loadDcmIntegrations());
    };

    vm.deactivateDcmIntegration = integration => {
      integration.isProcessBusy = true;
      return dcmIntegrationsProvider.deactivateIntegration({
        integrationId: integration.id,
      }).then(() => loadDcmIntegrations());
    };

    vm.deleteDcmIntegration = integration => {
      integration.isProcessBusy = true;
      return dcmIntegrationsProvider.deleteIntegration({
        integrationId: integration.id,
      }).then(() => loadDcmIntegrations());
    };

    vm.dcmIntegrationAction = integration => {
      if (vm.isDcmIntegrationActive(integration)) {
        vm.openDcmEditModal(integration);
      } else {
        vm.activateDcmIntegration(integration);
      }
    }

    vm.openDcmConfirmDeactivateModal = integration => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/dcm/dcmConfirmDeactivate.html?v=${window.BUILD_VERSION}`,
          controller: 'DcmConfirmDeactivateModalController',
          controllerAs: 'dcmConfirmDeactivateModalController',
          inputs: {
            integration,
            deactivate: vm.deactivateDcmIntegration,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(() => {
            removeBackdrop();
          });
        });
    };

    vm.openDcmConfirmDeleteModal = integration => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/dcm/dcmConfirmDelete.html?v=${window.BUILD_VERSION}`,
          controller: 'DcmConfirmDeleteModalController',
          controllerAs: 'dcmConfirmDeleteModalController',
          inputs: {
            integration,
            deleteIntegration: vm.deleteDcmIntegration,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(() => {
            removeBackdrop();
          });
        });
    };

    vm.openDcmSetupModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/dcm/dcm.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'DcmModalController',
          controllerAs: 'dcmModal',
          inputs: {
            provider: dcmIntegrationsProvider,
            integrations: vm.dcmIntegrations,
            allowedMetrics,
            allowedCountries,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              loadDcmIntegrations();
            }
          });
        });
    };

    vm.openDcmEditModal = integration => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/dcm/dcmEdit.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'DcmEditModalController',
          controllerAs: 'dcmEditModal',
          inputs: {
            provider: dcmIntegrationsProvider,
            integration,
            allowedMetrics,
            allowedCountries,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              loadDcmIntegrations();
            }
          });
        });
    };



    /* ************************************************************* */
    /* ************************** Freewheel ************************ */
    /* ************************************************************* */
    const allowedFreewheelMetrics = allowedMetrics.filter(item => item.key !== 'Viewability');

    const freewheelProvider = () => {
      const path = '/api/freewheel';

      return {
        create: params => $http.post(`${path}/integrations`, params),
        delete: params => $http.delete(`${path}/integrations`, { params }),
        update: params => $http.patch(`${path}/integrations`, params),
        credentials: params => $http.post(`${path}/credentials`, params),
        integrations: () => $http.get(`${path}/integrations/list`),
      }
    };

    const loadFreewheelIntegrations = () => {
      vm.isProcessFreewheelBusy = true;
      return freewheelProvider().integrations()
        .then(({ data }) => {
          vm.freewheelIntegrations = [
            ...data
          ];
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vm.isProcessFreewheelBusy = false;
        });
    };

    loadFreewheelIntegrations();

    vm.deleteFreewheelIntegration = integration => {
      integration.isProcessBusy = true;
      return freewheelProvider().delete({
        integrationCode: integration.integrationCode,
      });
    };

    vm.openFreewheelModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/freewheel/freewheel.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'FreewheelModalController',
          controllerAs: 'freewheelModal',
          inputs: {
            provider: freewheelProvider(),
            allowedMetrics: allowedFreewheelMetrics,
            allowedCountries,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              vm.isProcessFreewheelBusy = true;
              setTimeout(() => {
                loadFreewheelIntegrations();
              }, 2000);
            }
          });
        });
    };

    vm.openFreewheelEditModal = integration => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/freewheel/freewheelEdit.modal.html?v=${window.BUILD_VERSION}`,
          controller: 'FreewheelEditModalController',
          controllerAs: 'freewheelEditModal',
          inputs: {
            provider: freewheelProvider(),
            integration,
            allowedMetrics: allowedFreewheelMetrics,
            allowedCountries,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              loadFreewheelIntegrations();
            }
          });
        });
    };

    vm.openFreewheelConfirmDeleteModal = integration => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/settings/modals/freewheel/freewheelConfirmDelete.html?v=${window.BUILD_VERSION}`,
          controller: 'FreewheelConfirmDeleteModalController',
          controllerAs: 'freewheelConfirmDeleteModalController',
          inputs: {
            integration,
            deleteIntegration: vm.deleteFreewheelIntegration,
          }
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => {
            removeBackdrop();
            if (result) {
              loadFreewheelIntegrations();
            }
          });
        });
    };
  }
})();
